/**
 * Created by ganlu on 08/11/2016.
 */
import angular from 'angular';
import pwCheck from './pwcheck.directive';
import serverCheck from './servercheck.directive';
import pwdStrength from './pwdStrength.directive';
import emailCheck from './emailcheck.directive';
import './form.scss';

let formModule = angular.module('forms', [])
    .directive('pwCheck', pwCheck)
    .directive('serverCheck', serverCheck)
    .directive('pwdStrength', pwdStrength)
    .directive('emailCheck', emailCheck)
    .name;
    

export default formModule;



// WEBPACK FOOTER //
// ./src/app/common/form/form.js